import { StyleSheet } from 'react-native';
import { FOCUS_COLOR } from 'src/theme-v2/focus';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  title: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 24,
    color: neutrals.neutralGrays.graphite,
  },
  left_element_container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  backButton: {
    borderWidth: 2,
    borderColor: 'transparent',
    padding: 4,
  },
  backButtonFocus: {
    borderColor: FOCUS_COLOR,
  },
  backButtonInner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16.33,
  },
  backButtonText: {
    fontSize: 16,
    lineHeight: 22,
    fontWeight: 700,
    color: brand.main.water,
  },
  backButtonIcon: {
    width: 20,
    height: 20,
    padding: 4,
    color: brand.main.water,
  },
  button: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 18,
    paddingVertical: 8,
    flex: 1,
    flexDirection: 'row',
    gap: 10.31,
    width: 'auto',
    borderRadius: 100,
    backgroundColor: brand.main.water,
    shadowColor: brand.main.water,
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 4,
    minHeight: 40,
  },
  button_text: {
    color: neutrals.white,
    fontSize: 16,
    lineHeight: 22,
    fontWeight: 700,
    textAlign: 'center',
  },
  button_loader: {
    opacity: 0.8,
  },
  button_text_loader: {
    color: '#54c1c7ff',
  },
});
